import ENDPOINTS from 'api/endpoints';
import { doDelete, doGet, doPatch, doPost } from 'api/request';
import { LOGGER_TYPE } from 'api/types';
import { generateNextPath } from 'lib/routeHelper';
import type {
  PostStopKeyword,
  StopKeywordResponse,
  StopKeywordsResponse,
} from './types';

export const getStopKeywords = (accountId: string, projectId: string) => {
  return doGet<StopKeywordsResponse>(
    generateNextPath(ENDPOINTS.STOP_KEYWORDS, { accountId, projectId }),
    LOGGER_TYPE.JUPITER,
    { version: 'v2' },
  );
};

export const getStopKeyword = (
  accountId: string,
  projectId: string,
  stopKeywordId: string,
) => {
  return doGet<StopKeywordResponse>(
    generateNextPath(ENDPOINTS.STOP_KEYWORD, {
      accountId,
      projectId,
      stopKeywordId,
    }),
    LOGGER_TYPE.JUPITER,
    { version: 'v2' },
  );
};

export const postStopKeyword = ({
  accountId,
  projectId,
  stopKeywords,
}: {
  accountId: string;
  projectId: string;
  stopKeywords: PostStopKeyword;
}) => {
  return doPost<StopKeywordResponse>(
    generateNextPath(ENDPOINTS.STOP_KEYWORDS, {
      accountId,
      projectId,
    }),
    LOGGER_TYPE.JUPITER,
    stopKeywords,
    { version: 'v2' },
  );
};

export const patchStopKeyword = ({
  accountId,
  projectId,
  stopKeywordId,
  stopKeywords,
}: {
  accountId: string;
  projectId: string;
  stopKeywordId: string;
  stopKeywords: PostStopKeyword;
}) => {
  return doPatch<StopKeywordResponse>(
    generateNextPath(ENDPOINTS.STOP_KEYWORD, {
      accountId,
      projectId,
      stopKeywordId,
    }),
    LOGGER_TYPE.JUPITER,
    stopKeywords,
    { version: 'v2' },
  );
};

export const deleteStopKeyword = ({
  accountId,
  projectId,
  stopKeywordId,
}: {
  accountId: string;
  projectId: string;
  stopKeywordId: StopKeywordResponse['id'];
}) => {
  return doDelete<{ success: boolean }>(
    generateNextPath(ENDPOINTS.STOP_KEYWORD, {
      accountId,
      projectId,
      stopKeywordId,
    }),
    LOGGER_TYPE.JUPITER,
    undefined,
    { version: 'v2' },
  );
};
